import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminOrdenesCompraPage } from "@/features/admin-ordenes-compra/components/AdminOrdenesCompraPage";
import { ordenesCompraAdminQueryOptions } from "@/features/admin-ordenes-compra/hooks/use-ordenes-compra";

/**
 * Ruta `/admin/ordenes-compra` · precarga la primera página (sin filtro ·
 * debe coincidir con los params iniciales de AdminOrdenesCompraPage).
 */
export const Route = createFileRoute("/_authed-tw/admin/ordenes-compra/")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(ordenesCompraAdminQueryOptions({ page: 1, pageSize: 15 })),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminComprasSap]}>
      <AdminOrdenesCompraPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
